import { QtmCheckbox } from '@qtm/react';
import { useAppDispatch, useAppSelector } from 'hooks/redux';
import { UserTableModel, userTableColumns } from 'modules/Users/DataTableDef';
import DataTableRowActions from 'modules/Users/DataTableRowActions';
import DataTableRowItem from 'modules/Users/DataTableRowItem';
import { setSelection } from 'shared/reducers/usersTableSlice';

type Props = {
  user: UserTableModel;
};

const DataTableRow = ({ user }: Props) => {
  const dispatch = useAppDispatch();
  const selection = useAppSelector(state => state.usersTable.selection);
  const checked = selection.includes(user.id);

  const onCheckboxChange = () => {
    if (checked) {
      dispatch(setSelection(selection.filter(id => id !== user.id)));
    } else {
      dispatch(setSelection([...selection, user.id]));
    }
  };

  return (
    <tr>
      <td className="checkbox">
        <QtmCheckbox
          color="primary"
          size="medium"
          checked={checked}
          onValueChanged={onCheckboxChange}
        />
      </td>
      {userTableColumns.map(def => (
        <DataTableRowItem key={def.name} def={def} user={user} />
      ))}
      <DataTableRowActions user={user} />
    </tr>
  );
};

export default DataTableRow;
